import React from 'react';
import Routes from '../../consts/Routes';
import CTButton from './CTButton';

const HomePageButton = () => {
  return <CTButton pushParams={Routes.HOMEPAGE}>Homepage</CTButton>;
};

export default HomePageButton;
